import { z } from "zod";

export const CandidateActivityRequestSchema = z
  .object({ pageViewedAt: z.iso.datetime({ offset: true }) })
  .strict();

export type CandidateActivityRequestDto = z.infer<
  typeof CandidateActivityRequestSchema
>;
